import { Button } from '../../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { Stepper } from '../../../../../../../components/stepper/stepper';
import { LangSelect } from '../../../../../../../features/lang-select/lang-select';
import { CompanyAdminsCreateModalStep1 } from './company-admins-create-modal-step-1/company-admins-create-modal-step-1';
import { CompanyAdminsCreateModalStep2 } from './company-admins-create-modal-step-2/company-admins-create-modal-step-2';
import s from './company-admins-create-modal.module.css';
import { useCompanyAdminsCreateModal } from './use-company-admins-create-modal';

const steps = [<CompanyAdminsCreateModalStep1 />, <CompanyAdminsCreateModalStep2 />];

export const CompanyAdminsCreateModal = (props: ModalProps) => {
  const { t, id, step, handleNextStep, handlePrevStep, isHasNextStep, isHasPrevStep } =
    useCompanyAdminsCreateModal(props);

  return (
    <Modal
      {...props}
      className={s.feature}
      title={
        <div className={s.title}>
          {t(id ? 'Редактировать администратора' : 'Добавить администратора')}

          <LangSelect />
        </div>
      }
    >
      <Stepper current={step} totalSteps={steps.length} />
      {steps[step - 1]}
      <div className={s.controls}>
        <Button variant="secondary" onClick={handlePrevStep}>
          {t(isHasPrevStep ? 'Назад' : 'Отмена')}
        </Button>
        <Button onClick={handleNextStep}>{t(isHasNextStep ? 'Далее' : 'Сохранить')}</Button>
      </div>
    </Modal>
  );
};
